<div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
>
    <div>
        <table class="simple">
            <thead>
                <tr>
                    <th>#</th>
                    <th>
                        Documentos
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() && !eliminado && puedeEditar == true
                            "
                            mat-icon-button
                            color="accent"
                            (click)="agregar()"
                        >
                            <mat-icon>add</mat-icon>
                        </button>
                    </th>
                    <th class="text-right"></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let documento of documentos; let idx = index">
                    <td>{{ idx + 1 }}</td>
                    <td>
                        <span class="text-bold">{{
                            documento.tipo.descripcion
                        }}</span
                        ><br />
                        <span class="secondary-text">
                            Vencimiento: {{ documento.vencimiento }}
                        </span>
                    </td>
                    <td>
                        <button
                            mat-icon-button
                            type="button"
                            color="accent"
                            (click)="verDocumento(documento.id)"
                        >
                            <mat-icon>cloud_download</mat-icon>
                        </button>
                    </td>
                    <td>
                        <button
                            *ngIf="
                                _menuUsuarioSrvc.esSupervisor() && !eliminado && puedeEditar == true"
                            
                            mat-icon-button
                            color="warn"
                            (click)="eliminar(documento)"
                        >
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- div
    fxFlex
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayout.lt-md="column"
    fxLayoutAlign.lt-md="start center"
>
    <div>

        <thead>
            <tr>
                <th>#</th>
                <th>
                    Documentos
                    <button
                        *ngIf="_menuUsuarioSrvc.esSupervisor()"
                        mat-icon-button
                        color="accent"
                        (click)="agregarEspecialidad()"
                    >
                        <mat-icon>add</mat-icon>
                    </button>
                </th>
                <th class="text-right"></th>
            </tr>
        </thead>

        <mat-list>
            <mat-list-item
                *ngFor="let documento of documentos; let idx = index"
            >
                <h3 matLine>Documentos</h3>
                <p matLine>
                    <span class="text-bold"
                        >{{ idx + 1 }}.- {{ documento.tipo.descripcion }}</span
                    >


                    &nbsp;&nbsp;&nbsp;
                    <button
                        mat-icon-button
                        type="button"
                        color="accent"
                        (click)="verDocumento(documento.id)"
                    >
                        <mat-icon>cloud_download</mat-icon>
                        
                    </button>
                    
                </p>
                <p matLine>
                    <span class="secondary-text">
                        Vencimiento: {{ documento.vencimiento }}
                    </span>
                </p>
            </mat-list-item>
        </mat-list>
    </div>
    <div
        *ngIf="_menuUsuarioSrvc.esSupervisor()"
        fxFlex
        fxLayout="row"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start center"
        fxLayoutAlign="end end"
        style="height: 100%; width: 100%"
    >
    </div>
</div -->
